export const YotpoScript = () => {
  if (typeof window !== 'undefined') {
    const e = document.createElement('script');
    (e.type = 'text/javascript'),
      (e.async = true),
      (e.src =
        'https://staticw2.yotpo.com/lQ4CeYzdw3OtWNNjZlNguLjoyPQUjQ9VCuuFdAnJ/widget.js');
    e.id = 'YotpoBaseScript';
    const t = document.getElementsByTagName('script')[0];
    const b = document.getElementById('YotpoBaseScript');
    if (!b) {
      t.parentNode.insertBefore(e, t);
    }
  }

  CheckYotpoInitialized();
};

const CheckYotpoInitialized = () => {
  setTimeout(() => {
    if (typeof window !== 'undefined' && window.yotpo) {
      window.yotpoAPI = new Yotpo.API(yotpo);
      yotpoAPI.refreshWidgets();
    } else {
      CheckYotpoInitialized();
    }
  }, 1000);
};
